"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _MainLogo = _interopRequireDefault(require("./MainLogo"));

var _LanguageSelector = _interopRequireDefault(require("./LanguageSelector"));

var _ContactMenu = _interopRequireDefault(require("./ContactMenu"));

var _Profile = _interopRequireDefault(require("./Profile"));

var _Overview = _interopRequireDefault(require("./Overview"));

var _InlineSearch = _interopRequireDefault(require("./InlineSearch"));

var _render = require("../../utils/render.utils");

var _html = require("../../utils/html.utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HeaderTop = function HeaderTop(_ref) {
  var logosMainDouble = _ref.logosMainDouble,
      profileLabel = _ref.profileLabel,
      profileLoginLabel = _ref.profileLoginLabel,
      profileLogoutLabel = _ref.profileLogoutLabel,
      profileToggleLabel = _ref.profileToggleLabel,
      profileToggleChecked = _ref.profileToggleChecked,
      logosMainLink = _ref.logosMainLink,
      logosMainUrl = _ref.logosMainUrl,
      logosMainAlt = _ref.logosMainAlt,
      logosSubUrl = _ref.logosSubUrl,
      accessibilitySkipToLink = _ref.accessibilitySkipToLink,
      accessibilitySkipToLabel = _ref.accessibilitySkipToLabel,
      logosSubAlt = _ref.logosSubAlt,
      logosSubLink = _ref.logosSubLink,
      logosMainSmall = _ref.logosMainSmall,
      languagesOptions = _ref.languagesOptions,
      languagesActive = _ref.languagesActive,
      languagesChangeFunction = _ref.languagesChangeFunction,
      innerChangeLanguage = _ref.innerChangeLanguage,
      contactTitle = _ref.contactTitle,
      contactSections = _ref.contactSections,
      contactSocial = _ref.contactSocial,
      profileUser = _ref.profileUser,
      contactLabel = _ref.contactLabel,
      loginFunction = _ref.loginFunction,
      logoutFunction = _ref.logoutFunction,
      profileToggleFunction = _ref.profileToggleFunction,
      profileLinks = _ref.profileLinks,
      profileLoginAlt = _ref.profileLoginAlt,
      profileLogoutAlt = _ref.profileLogoutAlt,
      linksRenderFunction = _ref.linksRenderFunction,
      loading = _ref.loading,
      overviewLabel = _ref.overviewLabel,
      overviewLink = _ref.overviewLink,
      overviewAlt = _ref.overviewAlt,
      inlineSearchFunction = _ref.inlineSearchFunction,
      inlineSearchInfo = _ref.inlineSearchInfo,
      inlineSearchResults = _ref.inlineSearchResults,
      inlineSearchLabel = _ref.inlineSearchLabel,
      inlineSearchPlaceholder = _ref.inlineSearchPlaceholder,
      inlineSearchAllResultsText = _ref.inlineSearchAllResultsText,
      inlineSearchAllResultsLink = _ref.inlineSearchAllResultsLink;

  var fallbackShadowDomFocus = function fallbackShadowDomFocus() {
    var elem = (0, _html.querySelectorAllShadows)(accessibilitySkipToLink);

    if (elem && elem[0] && elem[0].focus) {
      elem[0].focus();
    }
  };

  return (0, _preact.h)("div", {
    id: "mtn-header-top",
    className: "o-header mtn-o-header__top"
  }, (0, _preact.h)("a", {
    id: "mtn-header-accessibility",
    href: accessibilitySkipToLink,
    onClick: fallbackShadowDomFocus,
    className: "mtn-o-header__accessibility a-button-negative o-header__button o-header__button-skip"
  }, accessibilitySkipToLabel), (0, _preact.h)(_MainLogo["default"], {
    doubleLogo: logosMainDouble,
    display: !(logosMainSmall || loading),
    loading: loading,
    logoLink: logosMainLink,
    logoUrl: logosMainUrl,
    logoAlt: logosMainAlt,
    linksRenderFunction: linksRenderFunction,
    subLogoLink: logosSubLink,
    subLogoUrl: logosSubUrl,
    subLogoAlt: logosSubAlt
  }), (0, _preact.h)("div", {
    id: "mtn-header-top-menus",
    className: "mtn-o-header__menus"
  }, (0, _preact.h)(_InlineSearch["default"], {
    inlineSearchFunction: inlineSearchFunction,
    allResultsText: inlineSearchAllResultsText,
    allResultsLink: inlineSearchAllResultsLink,
    buttonLabel: inlineSearchLabel,
    placeholder: inlineSearchPlaceholder,
    info: inlineSearchInfo,
    results: inlineSearchResults
  }), (0, _preact.h)(_Overview["default"], {
    label: overviewLabel,
    link: overviewLink,
    alt: overviewAlt
  }), (0, _preact.h)(_LanguageSelector["default"], {
    innerChangeLanguage: innerChangeLanguage,
    languagesChangeFunction: languagesChangeFunction,
    languagesActive: languagesActive,
    languages: languagesOptions,
    display: !!languagesActive
  }), (0, _preact.h)(_ContactMenu["default"], {
    linksRenderFunction: linksRenderFunction,
    title: contactTitle,
    buttonLabel: contactLabel,
    sections: contactSections,
    contactSocial: contactSocial
  }), (0, _preact.h)(_Profile["default"], {
    linksRenderFunction: linksRenderFunction,
    profileLinks: profileLinks,
    label: profileLoginLabel,
    noNameLabel: profileLabel,
    logoutLabel: profileLogoutLabel,
    loginAlt: profileLoginAlt,
    logoutAlt: profileLogoutAlt,
    user: profileUser,
    loginFunction: loginFunction,
    logoutFunction: logoutFunction,
    toggleLabel: profileToggleLabel,
    toggleFunction: profileToggleFunction,
    toggleChecked: profileToggleChecked
  }), logosMainSmall ? (0, _render.renderLink)(logosMainLink, (0, _preact.h)("img", {
    id: "mtn-header-top-logo-small",
    className: "mtn-o-header__logo--small",
    src: logosMainUrl
  }), '', linksRenderFunction) : null));
};

var _default = HeaderTop;
exports["default"] = _default;